export const createPaymentSlice = (set, get) => ({
  payment: {
    isProcessing: false,
    error: null,
    success: false,
  },
  paymentActions: {
    setIsProcessing: (isProcessing) =>
      set((state) => { state.payment.isProcessing = isProcessing }),
  
    setError: (error) =>
      set((state) => { state.payment.error = error }),
  
    setSuccess: (success) =>
      set((state) => { state.payment.success = success }),
  }
});
